import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "agent-list" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" Liste des agents affectés à la file : ", -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.fileName), 1)
    ]),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, (agent) => {
        return (_openBlock(), _createElementBlock("li", {
          key: agent.id,
          class: "agent-item"
        }, [
          _createElementVNode("span", null, _toDisplayString(agent.nom) + " " + _toDisplayString(agent.prenom), 1),
          _createElementVNode("button", {
            class: "btn-remove",
            onClick: ($event: any) => (_ctx.confirmerRetirer(agent.id))
          }, [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Retirer ", -1),
            _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
          ]))], 8, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createVNode(_component_router_link, {
      class: "btn btn-secondary mt-3",
      to: { name: 'ListeAffectationPage' }
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createTextVNode(" Retour à la liste des affectations ", -1)
      ]))]),
      _: 1
    })
  ]))
}